/*
*
* File JS componente Hero Section
*
*/

import $ from 'jquery';

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './cf7-form.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const cf7Form = () => {
    $('.collapse-btn').on('click', function(e) {
        e.preventDefault();
        const containerID = $(this).attr('aria-controls');
        $('#' + containerID).slideToggle();
    });

    $('.wpcf7-response-output').detach().insertBefore('.submit-button');

    const checkAcceptance = () => {
        let checkbox = document.querySelector('[name="acceptance-a"]:checked');
        let validValues = ['Si', 'Yes'];
        const cf7Submit = document.querySelector('.wpcf7-submit');

        if(!cf7Submit) {
            return;
        }

        if(!checkbox) {
            cf7Submit.setAttribute('disabled', true);
            return;
        }

        if(validValues.includes(checkbox.value)) {
            cf7Submit.removeAttribute('disabled');
        } else {
            cf7Submit.setAttribute('disabled', true);
        }
    }

    //checkAcceptance();
    
    // document.querySelectorAll('[name="acceptance-a"]').forEach((el) => {
    //     el.addEventListener('change', () => {
    //         checkAcceptance();
    //     })
    // })
}

export default cf7Form;

//--------------------------------------------------------------------//